<template>
    <button
        type="button"
        class="inline-flex items-center gap-x-2 rounded-lg bg-[#26272B] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:opacity-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
    >
        <slot></slot>
    </button>
</template>

<script setup lang="ts"></script>
